import API from '../AxiosInstance';

const unwrapList = (response) => response?.data || [];
const unwrapObject = (response) => response?.data || {};

const buildDeliveryParams = (payload) => ({
  ...(payload.eventType ? { eventtype: payload.eventType } : {}),
  ...(payload.status ? { status: payload.status } : {}),
  ...(payload.limit ? { limit: payload.limit } : {}),
  ...(payload.createdBefore ? { createdbefore: payload.createdBefore } : {}),
});

export default {
  getIntegrations(payload) {
    const params = payload.type ? { type: payload.type } : {};
    return API.get(`nodes/${payload.nodeId}/webhook-integrations`, { params }).then(unwrapList);
  },

  getIntegrationTypes(payload) {
    return API.get(`nodes/${payload.nodeId}/webhook-integrations/types`).then(unwrapList);
  },

  getIntegration(payload) {
    return API.get(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}`).then(unwrapObject);
  },

  createIntegration(payload) {
    const body = {
      name: payload.name,
      description: payload.description,
      type: payload.type,
      state: payload.state,
    };

    return API.post(`nodes/${payload.nodeId}/webhook-integrations`, body).then(unwrapObject);
  },

  updateIntegration(payload) {
    const body = {
      name: payload.name,
      description: payload.description,
      type: payload.type,
    };

    return API.patch(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}`, body).then(unwrapObject);
  },

  updateIntegrationState(payload) {
    return API.patch(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/state`, {
      state: payload.state,
    }).then(unwrapObject);
  },

  deleteIntegration(payload) {
    return API.delete(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}`).then(unwrapObject);
  },

  getEndpoints(payload) {
    return API.get(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/endpoints`).then(unwrapList);
  },

  getIntegrationDeliveries(payload) {
    return API.get(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/deliveries`, {
      params: buildDeliveryParams(payload),
    }).then(unwrapList);
  },

  getEndpointDeliverySummary(payload) {
    return API.get(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/endpoints/${payload.endpointId}/delivery-summary`, {
      params: buildDeliveryParams(payload),
    }).then(unwrapObject);
  },

  getEndpointDeliveries(payload) {
    return API.get(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/endpoints/${payload.endpointId}/deliveries`, {
      params: buildDeliveryParams(payload),
    }).then(unwrapList);
  },

  getEndpointDelivery(payload) {
    return API.get(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/endpoints/${payload.endpointId}/deliveries/${payload.deliveryId}`).then(unwrapObject);
  },

  createEndpoint(payload) {
    const body = {
      name: payload.name,
      url: payload.url,
      description: payload.description,
      state: payload.state,
      nodeid: payload.endpointNodeId,
      eventsubscriptions: payload.eventSubscriptions,
      allowteamonly: payload.allowTeamOnly,
    };

    return API.post(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/endpoints`, body).then(unwrapObject);
  },

  updateEndpoint(payload) {
    const body = {
      name: payload.name,
      url: payload.url,
      description: payload.description,
      nodeid: payload.endpointNodeId,
      eventsubscriptions: payload.eventSubscriptions,
      allowteamonly: payload.allowTeamOnly,
    };

    return API.patch(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/endpoints/${payload.endpointId}`, body).then(unwrapObject);
  },

  updateEndpointState(payload) {
    return API.patch(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/endpoints/${payload.endpointId}/state`, {
      state: payload.state,
    }).then(unwrapObject);
  },

  deleteEndpoint(payload) {
    return API.delete(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/endpoints/${payload.endpointId}`).then(unwrapObject);
  },

  rotateSigningSecret(payload) {
    return API.post(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/endpoints/${payload.endpointId}/signing-secret/rotate`).then(unwrapObject);
  },

  sendTest(payload) {
    return API.post(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/endpoints/${payload.endpointId}/test`).then(unwrapObject);
  },

  redeliver(payload) {
    return API.post(`nodes/${payload.nodeId}/webhook-integrations/${payload.integrationId}/endpoints/${payload.endpointId}/deliveries/${payload.deliveryId}/redeliver`).then(unwrapObject);
  },
}
